// extracted by mini-css-extract-plugin
export default {"UploadFailed":"UploadFailed___HjNKb"};